import s from './checkbox.module.scss'
import cx from 'classnames'

type Props = {
  inputProps?: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>
  containerClassName?: string
  children: React.ReactNode
}

export const CheckboxV3 = ({
  inputProps,
  containerClassName,
  children,
}: Props) => {
  return (
    <label className={cx(s.label, containerClassName)}>
      <input
        type="checkbox"
        {...inputProps}
        className={cx(s.checkbox, inputProps?.className)}
      />
      {children}
    </label>
  )
}
